"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
function useMobileHover(refs) {
  const {
    0: mobileHover,
    1: setMobileHover
  } = (0, _react.useState)(false);
  const pressDownTimeout = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    function mobilePressDown(e) {
      e.stopPropagation();
      setMobileHover(e.currentTarget.getAttribute("name"));
      pressDownTimeout.current = setTimeout(() => {
        setMobileHover(null);
      }, 1000);
    }
    function mobilePressUp(e) {
      e.stopPropagation();
      clearTimeout(pressDownTimeout);
      setMobileHover(null);
    }
    const elements = refs.current;
    elements.forEach(ref => {
      if (ref) {
        ref.addEventListener("touchstart", mobilePressDown);
        ref.addEventListener("touchend", mobilePressUp);
      }
    });
    return () => {
      elements.forEach(ref => {
        if (ref) {
          ref.removeEventListener("touchstart", mobilePressDown);
          ref.removeEventListener("touchend", mobilePressUp);
        }
      });
    };
  });
  return mobileHover;
}
var _default = useMobileHover;
exports.default = _default;